// kan-102: copy + owner-name resolution for the "this candidate already has an
// owner" notice. Kept free of hooks and side effects so it can be rendered and
// asserted on standalone, without mounting the 1000-line UpdateCandidate page.

export const OWNED_CANDIDATE_FALLBACK_OWNER = 'another recruiter';

// Router-state key used to hand the owner name from UpdateCandidate to
// ViewCandidate, which opens the notice as a blocking modal after it mounts.
// The update page cannot show it itself: the redirect unmounts that page (and,
// because private routes are keyed by index inside the Switch, MainLayout and
// its ToastContainer too), so anything raised there, toast included, is gone
// before the user can read it.
export const OWNED_NOTICE_STATE_KEY = 'ownedNoticeOwner';

export interface IOwnedCandidate {
  recruiterOwner?: { fullName?: string | null } | null;
}

export interface IOwnedCandidateNoticeProps {
  ownerName: string;
}

// Returns the owner's display name, or a neutral stand-in when the record has
// no name to show (missing relation, blank or whitespace-only fullName), so the
// sentence still reads correctly.
export const ownerDisplayName = (candidate?: IOwnedCandidate | null): string => {
  const fullName = candidate?.recruiterOwner?.fullName?.trim();
  return fullName ? fullName : OWNED_CANDIDATE_FALLBACK_OWNER;
};

const OwnedCandidateNotice = ({ ownerName }: IOwnedCandidateNoticeProps) => (
  <span>
    This candidate is already in ATS and is owned by{' '}
    <strong>{ownerName}</strong>. Only the owner can edit this record. You can
    still view the profile, or contact the owner if you need changes.
  </span>
);

export { OwnedCandidateNotice };
export default OwnedCandidateNotice;
